import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CompanyRankingForm } from './company-ranking-form';

export class CompanyFeeForm extends FormGroup<
  {
    id: FormControl<number | undefined>;
    CompanyId: FormControl<number | undefined>;
    // CompanyRankingId: FormControl<number | undefined>
    feeType: FormControl<
      'BASE' | 'RENEWAL' | 'MULTICLIENT' | 'PREFERRED' | undefined
    >;
    feeAmt: FormControl<number | undefined>;
    remittanceAmt: FormControl<number | undefined>;
    discountAmt: FormControl<number | undefined>;
  } & {
    CompanyRanking?: CompanyRankingForm;
  }
> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      // CompanyRankingId: new FormControl<number | undefined>(undefined, { nonNullable: true}),
      feeType: new FormControl<
        'BASE' | 'RENEWAL' | 'MULTICLIENT' | 'PREFERRED' | undefined
      >(undefined, { nonNullable: true, validators: [Validators.required] }),
      feeAmt: new FormControl<number | undefined>(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      remittanceAmt: new FormControl<number | undefined>(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      discountAmt: new FormControl<number | undefined>(0, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
